import { IconButton, Stack, Typography } from "@mui/material";
import moment from "moment";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import { DemoExResponse } from "src/services/admin/queries/NetTypes";

import ContextRow from "../Row/context";

export default function CreatedAt({ createdAt }: DemoExResponse) {
	const { state, actions } = useContext(ContextRow);

	return (
		<Stack direction={"row"} alignItems={"center"} gap={1}>
			<Typography variant='subtitle2'>{moment(createdAt).format("lll")}</Typography>
			<IconButton
				sx={{ p: 0.5 }}
				onClick={() => (!state.isColapsed ? actions.showColapsed() : actions.closeColapsed())}
			>
				<Iconify icon={!state.isColapsed ? "ri:arrow-right-s-line" : "ri:arrow-down-s-line"} />
			</IconButton>
		</Stack>
	);
}
